export enum ValidationTypeEnum {
    Required = 1,
    Compare = 2,
    NumericRange = 3,
    MinLength = 4,
    MaxLength = 5,
    RegularExpression = 6,
    Email = 7,
    DateRange = 8,
    Logic = 9,
    EitherOrRequired = 0
}

export enum ValidationActivation {
    Always = 0,
    OnlyWhenAnyFieldFilled = 1,
    OnlyWhenAllFieldFilled = 2
}

export class ValidationRule {
    property: string;

    parameters: string;

    errorMessage: string;

    validationType: ValidationTypeEnum;

    step?: number;
}

export class RulesHolder {
    entityName: string;
    rules: ValidationRule[];
    isCollection: boolean;
    activation: ValidationActivation;
    nestedRulesHolder: RulesHolder[];
}
